<template>
  <div ref="file" class="file" />
</template>

<script>
import {renderAsync} from 'docx-preview'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'App',
  data(){
    return {
      htmlContent:'',
    }
  },
  mounted(){
    this.previewFile()
  },
  methods:{
    previewFile(){
      if(window.location.href.includes("?")){
        const params = window.location.href.split('?')
        const from = qs.parse(params[1])?.['from'] ?? ''
        if(from){
          axios({
            method:"get",
            responseType:'blob',
            url:`${window.location.protocol}//cn-cdn-oss.duoke.net/contract/${from}.docx`,
          }).then(async (data)=>{
            await renderAsync(data.data,this.$refs.file)
          })
        }
      }
    },
  },
}
</script>

<style>
#app {
  width: 100%;
}
html,body{
  width:100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
}
.file{
  width: 100%;
}
.docx-wrapper{
  padding: 0 !important;
}
.docx-wrapper section{
  width: 100% !important;
  padding: 15px !important;
}
.docx-wrapper>section.docx{
  margin-bottom: 0 !important;
}
table tr td{
  border-width: 1px !important;
}
</style>
